export const CLASS_NAMES = {
  container: 'relative mr-3',
  logo: 'flex rounded-full h-16 min-h-16 w-16 min-w-16 bg-lavender-100 text-lavender-200 items-center justify-center m-2 overflow-hidden',
  img: '',
  progressIndicator: 'absolute top-0 left-0 right-0 bottom-0',
};
